module.exports = __webpack_public_path__ + "img/UTGOBL-5.80a640e7.jpg";